import { Box, Fab, Icon, Paper, Typography, CircularProgress, Alert } from '@mui/material';
import { Link, useHistory } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import DesktopAccessDisabledIcon from '@mui/icons-material/DesktopAccessDisabled';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import useFetchDataWithPagination from "../../../utility/useFetchDataWithPagination";
import { useEffect } from 'react';
import usePostData from '../../../utility/usePostData';
import SearchBar from '../component/SearchBar';
import { useState } from 'react';

const ListUser = () => {
    let { data: users, isLoading, error, paginate , refreshSearch , searchIntoDatabase, filterData, currentPage, perPage } = useFetchDataWithPagination("users");
    const startingIndex = ((users?.data?.current_page ?? currentPage) - 1) * (users?.data?.per_page ?? perPage);
    const {  submitData } = usePostData();
   // let listUser = users?.data?.data
    const history = useHistory();
    const [searchQuery, setSearchQuery] = useState("");
    let [listUser, setLlistUser] = useState(null);
    const [deleting, setDeleting] = useState(null);
    const [deleteError, setDeleteError] = useState(null);

    useEffect(() => {
        setLlistUser(filterData(searchQuery,users?.data?.data))
        return () => {
        };
    }, [filterData, searchQuery,users,paginate ]);

    const deleteUser = async (id, userName) => {
        const check = Math.random().toString(36).slice(2, 7);
        const response = window.prompt(
            `Êtes-vous sûr de vouloir supprimer ${userName} ?\n\nTapez: ${check}`
        );
        
        if (response === check) {
            try {
                setDeleting(id);
                setDeleteError(null);
                await submitData("/users/" + id, null, "DELETE");
                await refreshSearch();
            } catch (err) {
                setDeleteError(
                    err.response?.data?.message || 
                    "Erreur lors de la suppression de l'utilisateur"
                );
            } finally {
                setDeleting(null);
            }
        }
    }

    const updateSearch = (e) => {
        e.preventDefault();
        if(searchQuery === "") {
            //Recuperer tout les données
            searchIntoDatabase("users/search/ALL_DATA");
        }else{
            searchIntoDatabase("users/search/" + searchQuery );
        }
        
    }
        
    return (
        <Box sx={{
            m: 1,
            width: "95%",
            margin: "auto",
            mt: 3
        }}>
            <Paper elevation={2} sx={{ p: 3 }}>
                <div className="mb-4">
                    <Typography variant="h5" component="h4" sx={{ color: '#00a652', fontWeight: 500 }}>
                        Liste des utilisateurs
                    </Typography>
                    {isLoading && (
                        <div className="alert alert-info">
                            Chargement...
                        </div>
                    )}
                    {error && (
                        <div className="alert alert-danger">
                            {error}
                        </div>
                    )}
                    {deleteError && (
                        <Alert severity="error" sx={{ mt: 2 }}>
                            {deleteError}
                        </Alert>
                    )}
                </div>

                <div className="row align-items-center mb-4">
                    <div className="col-md-6"></div>
                    <div className="col-md-4">
                        <SearchBar setSearchQuery={setSearchQuery} handleSubmit={updateSearch} />
                    </div>
                    <div className="col-md-2">
                        <Link 
                            to="admin-add-user" 
                            className="btn d-flex align-items-center"
                            style={{ backgroundColor: '#00a652', color: 'white' }}
                        >
                            <PersonAddIcon sx={{ mr: 1 }} /> Ajouter
                        </Link>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr style={{ backgroundColor: '#00a652', color: 'white' }}>
                                <th>ID</th>
                                <th>Nom et Prénom</th>
                                <th>Email</th>
                                <th>Téléphone</th>
                                <th>Mobile</th>
                                <th>Role</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listUser && listUser.map((user, index) => (
                                <tr key={index}>
                                    {(user.role && !(user?.role.name.toLowerCase().includes('employeur'))) && (
                                        <>
                                            <td>{startingIndex + index + 1}</td>
                                            <td>{user?.name}</td>
                                            <td>{user?.email}</td>
                                            <td>{user?.telephone}</td>
                                            <td>{user?.mobile}</td>
                                            <td>
                                                <span style={{ 
                                                    backgroundColor: '#00773bbc', 
                                                    color: 'white',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontSize: '0.85rem'
                                                }}>
                                                    {user?.role?.name}
                                                </span>
                                            </td>
                                            <td>
                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    <Fab
                                                        size="small"
                                                        sx={{ backgroundColor: '#00a652', color: 'white', 
                                                            '&:hover': { backgroundColor: '#00a652' } 
                                                        }}
                                                        aria-label="edit"
                                                        onClick={() => { history.push("edit-user/" + user.id) }}
                                                        disabled={Boolean(deleting)}
                                                    >
                                                        <EditIcon />
                                                    </Fab>
                                                    <Fab
                                                        size="small"
                                                        sx={{ backgroundColor: '#ec1a20', color: 'white',
                                                            '&:hover': { backgroundColor: '#d41118' } 
                                                        }}
                                                        onClick={() => deleteUser(user?.id, user?.name)}
                                                        disabled={Boolean(deleting)}
                                                    >
                                                        {deleting === user?.id ? (
                                                            <CircularProgress size={24} sx={{ color: 'white' }} />
                                                        ) : (
                                                            <DesktopAccessDisabledIcon />
                                                        )}
                                                    </Fab>
                                                </Box>
                                            </td>
                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="mt-3">
                    {paginate()}
                </div>
            </Paper>
        </Box>
    );
}

export default ListUser;